export default "__VITE_ASSET__a0c4f6e6__"